export function localeToBcp47LangTag(locale) {
    if (!locale) {
        return locale;
    }
    locale = locale.replace(/_/gi, '-');
    // Legacy aliases
    if (locale === 'zh-TW') {
        return 'zh-Hant-TW';
    }
    if (locale === 'zh-CN') {
        return 'zh-Hans-CN';
    }
    // Special DBX mapping
    if (locale === 'es') {
        return 'es-419';
    }
    if (locale === 'es-ES') {
        return 'es';
    }
    return locale;
}
/*
 * Converts from the standard BCP47 locale codes to the Dropbox-specific locales used in rSERVER.
 */
export const bcp47ToDropboxLocale = (locale) => {
    // Legacy aliases
    if (locale === 'zh-Hant-TW') {
        return 'zh_TW';
    }
    if (locale === 'zh-Hans-CN') {
        return 'zh_CN';
    }
    // Special DBX mapping
    if (locale === 'es-419') {
        return 'es';
    }
    if (locale === 'es') {
        return 'es_ES';
    }
    return locale.replace(/-/gi, '_');
};
//# sourceMappingURL=locale_transforms.preenvesnextjs.map
